import { Link } from 'react-router-dom';
import { Calculator, Users, MapPin, Image, Briefcase, Globe2 } from 'lucide-react';

const quickLinks = [
  {
    to: '/simulateur-budget',
    icon: Calculator,
    title: 'Budget',
    description: 'Simulez votre budget',
    color: 'text-blue-600 dark:text-blue-400',
    bg: 'bg-blue-50 dark:bg-blue-900/20',
  },
  {
    to: '/matching',
    icon: Users,
    title: 'PVTmates',
    description: 'Trouvez des compagnons',
    color: 'text-teal-600 dark:text-teal-400',
    bg: 'bg-teal-50 dark:bg-teal-900/20',
  },
  {
    to: '/ambassades',
    icon: MapPin,
    title: 'Ambassades',
    description: 'Contacts officiels',
    color: 'text-orange-600 dark:text-orange-400',
    bg: 'bg-orange-50 dark:bg-orange-900/20',
  },
  {
    to: '/media',
    icon: Image,
    title: 'Media',
    description: 'Photos & videos',
    color: 'text-rose-600 dark:text-rose-400',
    bg: 'bg-rose-50 dark:bg-rose-900/20',
  },
  {
    to: '/jobs',
    icon: Briefcase,
    title: 'Emploi',
    description: 'Offres de job',
    color: 'text-emerald-600 dark:text-emerald-400',
    bg: 'bg-emerald-50 dark:bg-emerald-900/20',
  },
  {
    to: '/content',
    icon: Globe2,
    title: 'Actus',
    description: 'Restez informe',
    color: 'text-sky-600 dark:text-sky-400',
    bg: 'bg-sky-50 dark:bg-sky-900/20',
  },
];

export function QuickLinksSection() {
  return (
    <section>
      <div className="grid grid-cols-3 sm:grid-cols-6 gap-1.5 sm:gap-3">
        {quickLinks.map((link) => {
          const Icon = link.icon;
          return (
            <Link
              key={link.to}
              to={link.to}
              className="group flex flex-col items-center gap-1.5 sm:gap-2.5 p-2.5 sm:p-5 bg-white dark:bg-gray-800 rounded-xl sm:rounded-2xl border border-gray-100 dark:border-gray-700/50 hover:border-gray-200 dark:hover:border-gray-600 transition-all hover:shadow-md"
            >
              <div className={`p-2 sm:p-3 rounded-lg sm:rounded-xl ${link.bg} transition-transform group-hover:scale-110`}>
                <Icon className={`w-4 h-4 sm:w-6 sm:h-6 ${link.color}`} />
              </div>
              <div className="text-center">
                <span className="text-[11px] sm:text-sm font-semibold text-gray-900 dark:text-white block leading-tight">
                  {link.title}
                </span>
                <span className="text-[10px] sm:text-xs text-gray-400 dark:text-gray-500 hidden sm:block mt-0.5">
                  {link.description}
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
